import { environment } from "environments/environment";

export const GlobalVariable = Object.freeze({
    BASE_URL: environment.API_URL,
});

export const ApiUrls = Object.freeze({
    MEDIA_DOWNLOAD: `${GlobalVariable.BASE_URL}media/{0}/download/file`,
    MEDIA_UPLOAD: `${GlobalVariable.BASE_URL}media/upload`,
    MEDIA_DELETE: `${GlobalVariable.BASE_URL}media/`,


    CUSTOMER_CREATE: `${GlobalVariable.BASE_URL}customer/create`,
    LOGIN_WITH_TOKEN: `${GlobalVariable.BASE_URL}customer/loginWithToken`,
    VERIFY_CUSTOMER_SEND_OTP: `${GlobalVariable.BASE_URL}customer/verifyCustomerAndSendOtp`,
    SEND_OTP: `${GlobalVariable.BASE_URL}customer/sendOtp`,
    LOGIN_WITH_OTP: `${GlobalVariable.BASE_URL}customer/loginWithOtp`,
    GET_CONTACT_INFO: `${GlobalVariable.BASE_URL}customer/contactInfo/`,

    GET_VEHICLE_IMAGE: `${GlobalVariable.BASE_URL}vehicle/image/`,

    GET_BOOKINGS: `${GlobalVariable.BASE_URL}booking-details/findAll/`,
    GET_BOOKING_DETAILS: `${GlobalVariable.BASE_URL}booking-details/details/`,

    LOAN_APPLICATION: `${GlobalVariable.BASE_URL}loan-application/`,
    UPDATE_LOAN_APPLICATION: `${GlobalVariable.BASE_URL}loan-application/update`,
    SUBMIT_LOAN_APPLICATION: `${GlobalVariable.BASE_URL}loan-application/submit/`,
    APPLY_LOAN_APPLICATION: `${GlobalVariable.BASE_URL}loan-application/apply/`,
    DELETE_LOAN_APPLICATION_MEDIA: `${GlobalVariable.BASE_URL}loan-application/{0}/media/{1}`,

    LOAN_CALCULATOR_CONST: `${GlobalVariable.BASE_URL}master/loanCalculatorConst`,
    CONSTANT_VALUES: `${GlobalVariable.BASE_URL}master/constantsValues`,
    MASTER_DROPDOWN: `${GlobalVariable.BASE_URL}master/dropdown`,
    STATES: `${GlobalVariable.BASE_URL}master/states`,
    CITY_POSTCODE: `${GlobalVariable.BASE_URL}master/citiesAndPostCode`,
    BANK_BRANCH: `${GlobalVariable.BASE_URL}bank-branch/preferred`,

    FAQ_LIST: `${GlobalVariable.BASE_URL}faq/findAll`,
});

export const StorageConst = Object.freeze({
    TOKEN: 'accessToken',
    CURRENT_CUSTOMER: 'currentCustomer',
    BOOKING: 'booking',
    TIMER: 'timer',
});
